/* one% Benefits: card deck (Benefits Section.dc.html, variant "D · Card deck").
   - Enters when 20% in view; then cycles the front card every 4.2s.
   - Hover or click a title (or click a card) picks it and pauses the cycle for 6s.
   - Hovering the deck fans the cards out and pauses the cycle until the pointer leaves.
   - Reduced motion: shown at once, no auto-cycle; picking still works.
   - The cycle stops while the section is off-screen. */
(function () {
  if (customElements.get('op-benefits')) return;

  var CYCLE_MS = 4200;
  var RESUME_MS = 6000;

  class OpBenefits extends HTMLElement {
    connectedCallback() {
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-op-card]'));
      this.picks = Array.prototype.slice.call(this.querySelectorAll('[data-op-pick]'));
      this.deck = this.querySelector('[data-op-deck]');
      this.count = this.cards.length;
      this.active = 0;
      this.paused = false;
      this.visible = false;
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handlers = [];

      this.render();

      var self = this;
      this.picks.forEach(function (btn) {
        var i = Number(btn.getAttribute('data-op-pick'));
        self.on(btn, 'mouseenter', function () { self.pick(i); });
        self.on(btn, 'click', function () { self.pick(i); });
      });
      this.cards.forEach(function (card) {
        var i = Number(card.getAttribute('data-op-card'));
        self.on(card, 'click', function () { self.pick(i); });
      });
      if (this.deck) {
        this.on(this.deck, 'mouseenter', function () { self.paused = true; self.classList.add('is-fan'); });
        this.on(this.deck, 'mouseleave', function () { self.paused = false; self.classList.remove('is-fan'); });
      }

      if (this.reduce || !('IntersectionObserver' in window)) {
        this.classList.add('is-in');
        return;
      }

      // Entrance: once, at 20% visibility. Then the cycle runs only while on screen.
      this.enterIo = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          self.classList.add('is-in');
          self.enterIo.disconnect();
          self.started = true;
          self.syncCycle();
        }
      }, { threshold: 0.2 });
      this.enterIo.observe(this);

      this.viewIo = new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
        self.syncCycle();
      });
      this.viewIo.observe(this);
    }

    disconnectedCallback() {
      this.enterIo && this.enterIo.disconnect();
      this.viewIo && this.viewIo.disconnect();
      clearInterval(this.cycle);
      clearTimeout(this.resume);
      this.handlers.forEach(function (h) { h[0].removeEventListener(h[1], h[2]); });
      this.handlers = [];
    }

    on(el, type, fn) {
      el.addEventListener(type, fn);
      this.handlers.push([el, type, fn]);
    }

    syncCycle() {
      var self = this;
      var shouldRun = this.started && this.visible && this.count > 1 && !this.reduce;
      if (shouldRun && !this.cycle) {
        this.cycle = setInterval(function () {
          if (!self.paused) self.setActive((self.active + 1) % self.count);
        }, CYCLE_MS);
      } else if (!shouldRun && this.cycle) {
        clearInterval(this.cycle);
        this.cycle = null;
      }
    }

    pick(i) {
      var self = this;
      this.paused = true;
      clearTimeout(this.resume);
      this.resume = setTimeout(function () { self.paused = false; }, RESUME_MS);
      this.setActive(i);
    }

    setActive(i) {
      if (i < 0 || i >= this.count) return;
      this.active = i;
      this.render();
    }

    render() {
      var n = this.count;
      var active = this.active;
      this.cards.forEach(function (card, i) {
        var r = (i - active + n) % n; // 0 = front card
        card.setAttribute('data-pos', String(Math.min(r, 2)));
        card.style.setProperty('--z', String(n - r));
      });
      this.picks.forEach(function (btn, i) {
        btn.setAttribute('aria-pressed', i === active ? 'true' : 'false');
      });
    }
  }

  customElements.define('op-benefits', OpBenefits);

  // Theme editor: selecting a card block brings that card to the front and holds it there.
  document.addEventListener('shopify:block:select', function (e) {
    var target = e.target;
    var root = target && target.closest && target.closest('op-benefits');
    if (!root || !root.pick) return;
    var i = Number(target.getAttribute('data-op-pick'));
    if (!isNaN(i)) {
      root.paused = true;
      clearTimeout(root.resume);
      root.setActive(i);
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target && e.target.closest && e.target.closest('op-benefits');
    if (root) root.paused = false;
  });
})();
